import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { InventoryDialogComponent } from '@app/modules/counts/inventory-dialog/inventory-dialog.component';
import { Store } from '@ngrx/store';
import { ChartType, ChartOptions, ChartDataset, ChartData } from 'chart.js';
import * as CountsActions from '@app/modules/counts/store/actions/counts.actions';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';

@Component({
  selector: 'app-lowstock-pie-chart',
  templateUrl: './lowstock-pie-chart.component.html',
  styleUrls: ['./lowstock-pie-chart.component.scss']
})
export class LowstockPieChartComponent implements OnInit {
  public pieChartLabels: string[] = [];
  
  constructor(
    private store$: Store,
    public _translate: TranslateService,
  ) {
    this._translate.get(['totalMSL', 'totalOrder']).pipe(first()).subscribe(translation => {
      this.pieChartLabels = [translation.totalMSL, translation.totalOrder];
    });
  }

  public pieChartOptions: ChartOptions = {
    responsive: true,
    onClick: (event: any, array: any) => {
      if (array.length > 0) {
        const index  = array[0]._index;

        switch(index){
          case 0:
            this.store$.dispatch(CountsActions.setCurrentType({ currentType: 'count' }));
          break;
          case 1:
            this.store$.dispatch(CountsActions.setCurrentType({ currentType: 'reorder' }));
          break;
        }
      }
    },
  };

  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;

  @Input() total = 10000000;
  @Input() reorder = 50;
  @Input() stocked = 1000;
  @ViewChild('myChart') myChart = 1000;

  public pieChartData: ChartData<'pie'> = {
    labels: this.pieChartLabels, 
    datasets: [
      {
        data: [this.stocked, this.reorder], 
        backgroundColor: ['#37B648', '#0E0D2C'], 
      }
    ]
  };

  ngOnInit() {
  }

}
